<template>
  <section class="w-screen h-screen fixed flex inset-0 justify-center items-center z-50">
    <div v-if="showModal" class="absolute inset-0 bg-black bg-opacity-50" @click="closeModal"></div>
    <div id="modal modal-customer" class="modal absolute block w-5/12 bg-white shadow-md rounded-lg"
        :class="{
        'animate__animated animate__zoomIn': showModal,
        'animate__animated animate__zoomOut': !showModal,
        }">
        <div id="modal-header" class="w-full bg-color-1 py-3 rounded-t-lg">
          <h5 class="text-white text-center font-bold text-xl">{{ isEdit ? 'Edit Kategori' : 'Tambah Kategori' }}</h5>
        </div>
        <div id="modal-body" class="p-5">
          Lepas status unavailable/maintenance?
        </div>
        <div class="modal-footer p-5">
          <div class="flex justify-center">
            <SubmitButton id="close" button_name="Close" button_class="mx-1 text-red-600 border-red-600 hover:text-white hover:bg-red-600" @click="closeModal"/>
            <SubmitButton id="submit" button_name="Submit" button_class="mx-1 bg-color-1 hover:bg-color-2 text-color-4" @click="submitTable"/>
          </div>
        </div>
    </div>
  </section>
</template>

<script>
import SubmitButton from '@/components/form/SubmitButton.vue';
// import { mapActions, mapGetters } from 'vuex';

export default {
  name: "ModalCategory",
  props: {
    category: {
      type: Object,
      default: null,
    },
    id: {
      type: String,
      default: null,
      required: true,
    }
  },
  components: {
    SubmitButton
  },
  data() {
    return {
      showModal: true,
      categoryName: this.category ? this.category.name : '',
      categoryDivision: this.category ? this.category.printer_list || [] : [],
      categoryStatus: this.category ? this.category.status : 'active',
      isEdit: !!this.category
    };
  },
  computed: {
    // ...mapGetters('kitchen_divisions', ['allKitchenDivisions']),
  },
  created() {
    // this.$store.dispatch('kitchen_divisions/fetchKitchenDivisions');
  },  
  watch: {
    category(newValue) {
      if (newValue) {
        this.categoryName = newValue.name;
        this.categoryDivision = newValue.divisi || [];
        this.categoryStatus = newValue.status;
        this.isEdit = true;
      } else {
        this.categoryName = '';
        this.categoryDivision = [];
        this.categoryStatus = true;
        this.isEdit = false;
      }
    }
  },
  methods: {
    // ...mapActions('item_categories', ['createItemCategory', 'updateItemCategory']),
    closeModal() {
      this.showModal = false;
      this.$emit('closeModal');
      setTimeout(() => {
        this.$emit('closeModal');
      }, 200); 
    },
    // async submitCategory() {
    //   try {
    //     const categoryData = {
    //       name: this.categoryName,
    //       printer_list: this.categoryDivision,
    //       status: this.categoryStatus
    //     };

    //     if(this.isEdit && this.category) {
    //       categoryData.id = this.category.id;
    //       await this.updateItemCategory(categoryData);
    //     }
    //     else {
    //       await this.createItemCategory(categoryData);
    //     }

    //     this.closeModal();
    //   }
    //   catch (error) {
    //     console.error('Failed to save category: ', error);
    //   }
    // }
    async submitTable() {
      await this.$store.dispatch('tables/updateTable', { id: this.id, status: 'available' });
      this.closeModal();
    },
  }
}
</script>